var _style, _path, _g, _circle, _circle2, _circle3, _g2, _g3, _path2, _path3, _path4, _defs, _path5, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 309.4 427.3",
    style: {
      enableBackground: "new 0 0 309.4 427.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6EEF4;}\n\t.st1{opacity:0.25;}\n\t.st2{fill:#FFFFFF;stroke:#000000;stroke-width:0.4993;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#2159D1;stroke:#2159D1;stroke-width:0.1038;stroke-miterlimit:10;}\n\t.st4{fill:#2159D1;}\n\t.st5{fill:#2A6DFF;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{clip-path:url(#SVGID_00000016769201463591337890000013122049092252884156_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.7,0h-280C6.6,0,0,6.6,0,14.7v397.9c0,8.1,6.6,14.7,14.7,14.7h280c8.1,0,14.7-6.6,14.7-14.7V14.8 C309.4,6.7,302.8,0,294.7,0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "matrix(-1,0,0,1.0029884,167.08008,-0.362593)",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5_00000015330098891938671410000013543301179922527627_",
    className: "st2",
    d: "M147.1,398.2c0,6.1-5,11.1-11.1,11.1h-247.3 c-6.1,0-11.1-5-11.1-11.1V28.6c0-6.1,5-11.1,11.1-11.1H136c6.1,0,11.1,5,11.1,11.1V398.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7_00000100375537467663419840000013503850537899925131_",
    className: "st3",
    d: "M99.7,17.9h6.7l40.3,40.4V65 C146.7,65.1,99.7,17.9,99.7,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    className: "st3",
    d: "M128.2,17.9h6.7l11.8,11.8v6.7L128.2,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    className: "st3",
    d: "M72.8,17.9h6.7l67.2,67.4V92C146.7,92.1,72.8,17.9,72.8,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    className: "st3",
    d: "M19,17.9h6.7l120.9,121.4l0.3,6.8L19,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    className: "st3",
    d: "M-7.9,17.8h6.7l147.8,148.4l-0.1,6.6L-7.9,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    className: "st3",
    d: "M-34.7,17.8h6.7l174.7,175.3l0.1,6.6L-34.7,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    className: "st3",
    d: "M-61.6,17.8h6.7l201.6,202.3v6.7L-61.6,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    className: "st3",
    d: "M-88.5,17.8h6.7l228.4,229.3v6.7L-88.5,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    className: "st3",
    d: "M-113.7,18.5l5.3-0.7l255.1,256.3v6.7L-114.8,18.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    className: "st3",
    d: "M45.9,17.9h6.7l94,94.4v6.7C146.7,119,45.9,17.9,45.9,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    className: "st3",
    d: "M-122,38.1v-6.7L146.6,301v6.7L-115.3,44.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    className: "st3",
    d: "M-122,65.1v-6.7L146.6,328v6.7L-115.3,71.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31_00000175298119841965150450000009412118104823459230_",
    className: "st3",
    d: "M-122,92.1v-6.7L146.6,355v6.7L-115.3,98.8 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33_00000020399157554765973560000018003338562662742195_",
    className: "st3",
    d: "M-122,119v-6.7l268.6,269.6v6.7 l-261.9-262.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path35_00000113337232507369421760000016467229300099853720_",
    className: "st3",
    d: "M-122,172.9v-6.7l241.8,242.7h-6.7 l-228.3-229.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37_00000078742846536070016510000001512691333687226762_",
    className: "st3",
    d: "M-122,199.9v-6.7L92.9,408.9h-6.7 l-201.5-202.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39_00000067939922762668734100000014151006774787890362_",
    className: "st3",
    d: "M-122,146v-6.7l265.3,266.2l-1.7,1.7h-3.4 l-253.5-254.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41_00000106134727398346517220000008280159479525335702_",
    className: "st3",
    d: "M-122,226.9v-6.7L66.1,408.9h-6.7 L-122,226.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43_00000021110851022699208340000009783917002429398151_",
    className: "st3",
    d: "M-122,253.8v-6.7L39.2,408.9h-6.7 C32.5,408.9-122,253.8-122,253.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45_00000029735629954526553940000004353846695663003306_",
    className: "st3",
    d: "M-122,280.8v-6.7L12.3,408.9H5.6 C5.6,408.9-122,280.8-122,280.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47_00000178165633370106389280000011933680497314694075_",
    className: "st3",
    d: "M-122,307.8v-6.7L-14.5,409h-6.7 L-122,307.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49_00000132775900695591097020000002632433641347962508_",
    className: "st3",
    d: "M-122,334.7V328l80.6,80.9h-6.7L-122,334.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51_00000115487952059002476470000010658737565606530494_",
    className: "st3",
    d: "M-122,361.7V355l53.7,53.9H-75L-122,361.7z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53_00000178166756893683904900000008204942414761921440_",
    className: "st3",
    d: "M-122,388.6v-6.7l26.9,27h-6.7L-122,388.6 L-122,388.6z"
  }))), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 154.7,
    cy: 213.7,
    r: 100
  })), /*#__PURE__*/React.createElement("g", null, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 154.7,
    cy: 213.7,
    r: 89.4
  })), /*#__PURE__*/React.createElement("g", null, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 154.7,
    cy: 213.7,
    r: 74
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M183.5,167.1c-17.3,0.4-31.2,14.3-31.2,30.1c0,15.9,13.8,29.5,31.2,30.1c17.3,0,31.2-14.3,31.2-30.1 C214.7,181.4,200.8,167.5,183.5,167.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M202.4,197.3c0-10.1-8.4-18.4-18.8-18.4c-10.4,0-18.8,8.2-18.8,18.4c0,10.1,8.4,18.4,18.8,18.4 C193.9,215.6,202.4,207.4,202.4,197.3z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M159.9,237.5c-9.2,0-16.6,7.3-16.6,15.8c0,8.5,7.3,15.7,16.6,15.7c9.4-0.3,16.6-7.2,16.6-15.7 C176.5,244.8,169.1,237.8,159.9,237.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M166.3,253.2c0-3.4-2.9-6.2-6.4-6.2s-6.4,2.8-6.4,6.2c0,3.4,2.9,6.2,6.4,6.2 C163.4,259.5,166.3,256.7,166.3,253.2z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M135.6,187.9c-3.8,0-7.2,3.1-7.2,6.7c0,3.7,3.2,6.7,7.2,6.7c4.1,0,7.2-3,7.2-6.7 C142.8,191,139.5,187.9,135.6,187.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M111.6,236.5c-3.8,0-7.2,3.1-7.2,6.7c0,3.7,3.2,6.7,7.2,6.7c4.1,0,7.2-3,7.2-6.7 C118.8,239.6,115.5,236.5,111.6,236.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M198.3,245.4c-3.8,0-7.2,3.1-7.2,6.7s3.2,6.7,7.2,6.7c4.1,0,7.2-3,7.2-6.7S202.2,245.4,198.3,245.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 154.7,
    cy: 213.7,
    r: 74
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000175306342868985233930000002064771812565438633_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000175306342868985233930000002064771812565438633_)"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M113.2,149.1c-9.2-0.6-17.1,6.2-17.6,14.7s6.4,16.1,15.7,16.7c9.4,0.3,17.1-6.2,17.6-14.6 C129.4,157.3,122.4,149.9,113.2,149.1z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M118.6,165.2c0.2-3.4-2.5-6.4-6-6.6s-6.6,2.4-6.8,5.8s2.5,6.4,6,6.6 C115.4,171.2,118.4,168.6,118.6,165.2z"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBack);
export default __webpack_public_path__ + "static/media/card_back.5f82a79a1f8af769ce7e2ca7cece1dbf.svg";
export { ForwardRef as ReactComponent };